"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const assets_1 = require("~/assets");
const AddressesController_module_scss_1 = __importDefault(require("./AddressesController.module.scss"));
const AddressEditor_1 = __importDefault(require("../AddressEditor"));
function AddressesController({ addressesArr, onValidStateChange, onAddressesChange }) {
    const { t } = (0, react_i18next_1.useTranslation)('quote-widget');
    const [addresses, setAddresses] = (0, react_1.useState)(addressesArr.map((address) => {
        return { address, isValid: true };
    }));
    const [temporaryId, setTemporaryId] = (0, react_1.useState)(-1);
    const [areAllAddressesValid, setAreAllAddressesValid] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        onValidStateChange(areAllAddressesValid);
    }, [areAllAddressesValid]);
    (0, react_1.useEffect)(() => {
        onAddressesChange(addresses.map((addressSate) => addressSate.address));
    }, [addresses]);
    // TODO: remove hardcoded country id
    const usaCountryID = 230;
    const addAddress = () => {
        setTemporaryId((prevTemporaryId) => prevTemporaryId - 1);
        setAddresses((prevAddresses) => {
            return [
                ...prevAddresses,
                {
                    address: {
                        id: temporaryId,
                        addressLine: '',
                        city: '',
                        state: '',
                        zip: '',
                        country_id: usaCountryID,
                    },
                    isValid: false,
                },
            ];
        });
        setAreAllAddressesValid(false);
    };
    const onAddressChange = (address) => {
        setAddresses((prevAddresses) => {
            const newAddresses = prevAddresses.slice();
            const oldAddressState = newAddresses.find((addressState) => addressState.address.id === address.id);
            const index = newAddresses.indexOf(oldAddressState);
            newAddresses[index] = Object.assign(Object.assign({}, oldAddressState), { address });
            return newAddresses;
        });
    };
    const updateValidState = (newAddresses) => {
        setAreAllAddressesValid(newAddresses.every((address) => address.isValid));
    };
    const onAddressValidStateChange = (id, isValid) => {
        const newAddresses = addresses.slice();
        const oldAddressState = newAddresses.find((addressState) => addressState.address.id === id);
        const index = newAddresses.indexOf(oldAddressState);
        newAddresses[index] = Object.assign(Object.assign({}, oldAddressState), { isValid });
        setAddresses(newAddresses);
        updateValidState(newAddresses);
    };
    const onAddressDelete = (id) => {
        const newAddresses = addresses.slice();
        const index = newAddresses.indexOf(newAddresses.find((address) => address.address.id === id));
        newAddresses.splice(index, 1);
        setAddresses(newAddresses);
        updateValidState(newAddresses);
    };
    return (react_1.default.createElement("div", { className: AddressesController_module_scss_1.default.content },
        react_1.default.createElement("div", { className: AddressesController_module_scss_1.default.title, onClick: addAddress, onKeyDown: (e) => e.key === 'Enter' && addAddress(), tabIndex: 0, role: "button" },
            t('title.shipping-to-address'),
            react_1.default.createElement("img", { src: assets_1.svgBasicAddNewDark, alt: "plus sign" })),
        react_1.default.createElement("div", { className: AddressesController_module_scss_1.default.block }, addresses
            ? Array.from(addresses.values()).map((addressState) => {
                const { address } = addressState;
                return (react_1.default.createElement("div", { className: AddressesController_module_scss_1.default.address, key: address.id },
                    react_1.default.createElement(AddressEditor_1.default, { address: address, onValidStateChange: onAddressValidStateChange, onAddressChange: onAddressChange, onAddressDelete: onAddressDelete })));
            })
            : null)));
}
exports.default = AddressesController;
